module.exports = __webpack_public_path__ + "img/slimec.e7f09354.png";